/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts';

import type { DistributeIncentive } from './DistributeIncentive';

export class DistributeIncentiveFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<DistributeIncentive> {
    return super.deploy(overrides || {}) as Promise<DistributeIncentive>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DistributeIncentive {
    return super.attach(address) as DistributeIncentive;
  }
  connect(signer: Signer): DistributeIncentiveFactory {
    return super.connect(signer) as DistributeIncentiveFactory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): DistributeIncentive {
    return new Contract(address, _abi, signerOrProvider) as DistributeIncentive;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'Seller',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'Buyer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'Value',
        type: 'uint256',
      },
    ],
    name: 'SendIncentive',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'Admin',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'addFund',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'dayswappers',
    outputs: [
      {
        internalType: 'contract IDayswappers',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getFund',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'kycDapp',
    outputs: [
      {
        internalType: 'contract IKycDapp',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nrtManager',
    outputs: [
      {
        internalType: 'contract INRTManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'prepaidEs',
    outputs: [
      {
        internalType: 'contract IPrepaidEs',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'randomnessManager',
    outputs: [
      {
        internalType: 'contract RandomnessManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'removeAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_username',
        type: 'bytes32',
      },
    ],
    name: 'resolveAddress',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_username',
        type: 'bytes32',
      },
    ],
    name: 'resolveAddressStrict',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_wallet',
        type: 'address',
      },
    ],
    name: 'resolveUsername',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_wallet',
        type: 'address',
      },
    ],
    name: 'resolveUsernameStrict',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_seller',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_buyer',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_incentivefortxn',
        type: 'uint256',
      },
    ],
    name: 'sendIncentive',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'setAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_kycDapp',
        type: 'address',
      },
    ],
    name: 'setKycDapp',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'timeallyClub',
    outputs: [
      {
        internalType: 'contract ITimeAllyClub',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'timeallyManager',
    outputs: [
      {
        internalType: 'contract ITimeAllyManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'timeallyPromotionalBucket',
    outputs: [
      {
        internalType: 'contract ITimeAllyPromotionalBucket',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'validatorManager',
    outputs: [
      {
        internalType: 'contract IValidatorManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawFund',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';
